import ImageBox from './ImageBox';
import ModelName from './ModelName';
import TitledContents from './TitledContents';
import Details from './Details';

export default function ProductBox(props) {
  const product = props.product;

  const images = product.images ?? [];
  const company = product.company ?? "";
  const modelName = product.modelName ?? "";
  const modelDesc = product.modelDesc ?? "";
  const modelInfo = product.modelInfo ?? [];
  //const table = products[index].details?.table?? <></>;

  return (
    <div className="flex items-start w-full flex-col lg:w-[1200px] my-10">
      <div className="flex flex-col lg:flex-row ">
        <ImageBox images={images}/>
        <div className="flex-col lg:ml-10 lg:max-w-[700px]">
          <ModelName company={company} modelName={modelName} modelDesc={modelDesc} modelInfo={modelInfo}/>
          <TitledContents product={product} />
          <Details product={product}></Details>
        </div>
      </div>
      <div className="h-[1px] w-full bg-gray-300 mt-10"/>
    </div>
  );
}